import { render, staticRenderFns } from "./safety_password.vue?vue&type=template&id=9e96a7ca"
import script from "./safety_password.vue?vue&type=script&lang=js"
export * from "./safety_password.vue?vue&type=script&lang=js"
import style0 from "./safety_password.vue?vue&type=style&index=0&id=9e96a7ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports